import { Navigate, useRoutes } from "react-router-dom";
import HomeScreen from "./pages/home";
import { EventDetails } from "./pages/event-details";
import { Checkout } from "./pages/checkout";
import DashboardLayout from "./layouts/dashboard";
import Events from "./pages/back-office/event/events";
import AddEvent from "./pages/back-office/event/manage-event";
import Coupons from "./pages/back-office/coupon/coupons";
import AddCoupon from "./pages/back-office/coupon/manage-coupon";
import ContactUs from "./pages/contact-page";
import BookTicket from "./pages/back-office/issue-ticket";
import Orders from "./pages/back-office/order";
import Profile from "./pages/back-office/profile";
import CheckoutSuccessPage from "./pages/checkout-summary";
import TermsAndCondition from "./pages/terms-condition/terms";
import PrivacyAndPolicy from "./pages/privacy-policy";
import ViewTicket from "./pages/view-ticket";
import SalesReport from "./pages/back-office/sales-report";
import ServiceFeeSettings from "./pages/back-office/service-fee";

export const AdminRouter = () => {
  const routes = useRoutes([
    {
      path: "*",
      element: <HomeScreen />,
      index: true,
    },
    {
      path: "/login",
      element: <Navigate to="/dashboard/sales-report" />,
    },
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/sales-report" />, index: true },
        { path: "*", element: <SalesReport /> },
        { path: "sales-report", element: <SalesReport /> },
        { path: "events", element: <Events /> },
        { path: "event/add", element: <AddEvent /> },
        { path: "event/:id/edit", element: <AddEvent /> },
        { path: "coupons", element: <Coupons /> },
        { path: "coupon/add", element: <AddCoupon /> },
        { path: "coupons/:id/edit", element: <AddCoupon /> },
        { path: "book-ticket", element: <BookTicket /> },
        { path: "orders", element: <Orders /> },
        { path: "service-fee", element: <ServiceFeeSettings /> },
        { path: "profile", element: <Profile /> },
      ],
    },

    {
      path: "home",
      element: <HomeScreen />,
    },
    {
      path: "event/:eventName",
      element: <EventDetails />,
    },
    { path: "checkout", element: <Checkout /> },
    { path: "view-ticket", element: <ViewTicket /> },
    { path: "contact-us", element: <ContactUs /> },
    { path: "checkout-successful", element: <CheckoutSuccessPage /> },
    { path: "checkout-successful/:id", element: <CheckoutSuccessPage /> },
    { path: "terms-and-conditions", element: <TermsAndCondition /> },
    { path: "privacy-and-policy", element: <PrivacyAndPolicy /> },
  ]);

  return routes;
};
